export default {
  logoAlt: "لوگوی {{siteTitle}}",
  nav: {
    home: "خانه",
    about: "درباره ما",
    contact: "تماس",
  },
  about: {
    javad: "جواد",
    faranack: "فرانک",
  },
  theme: {
    toLight: "تغییر به حالت روشن",
    toDark: "تغییر به حالت تاریک",
  },
  language: {
    toFa: "تغییر به فارسی",
    toEn: "تغییر به انگلیسی",
  },
};
